import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Home from '../Home/Home';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

const ThankYou = () => {
  const navigate = useNavigate();
  const formData = JSON.parse(sessionStorage.getItem('updatedFormData'));
  const [openLoader, setOpenLoader] = useState(false);

  useEffect(() => {
    if (!formData) {
      navigate('/');
    }
  }, [formData, navigate]);

  const handleProceedToPayment = async () => {
    setOpenLoader(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/payment/create/order`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          cart: [{ id: 'ticket', quantity: formData.totalTicketPrice }],
          userId: formData.userId,
          emailId: formData.email,
          eventId: formData.eventId,
          eventType: formData.eventType,
        }),
      });

      const data = await response.json();


      if (data.approvalUrl) {
        sessionStorage.setItem('userId', formData.userId);
        sessionStorage.setItem('emailId', formData.email);
        sessionStorage.setItem('eventId', formData.eventId)
        sessionStorage.setItem('eventType', formData.eventType);
        window.location.href = data.approvalUrl; // 🔁 Redirect to PayPal
        setOpenLoader(false);
      } else {
        alert('Unable to create PayPal order.');
      }
    } catch (error) {
      console.error('Payment initiation failed:', error);
      alert('Something went wrong. Please try again later.');
      setOpenLoader(false);
    }
  };

  if (!formData) return null;

  return (
      <Home>
        <Backdrop 
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} 
        open={openLoader}>
            <CircularProgress color="inherit" />
     </Backdrop>
        <div className="container">
          <h1>Thank You {formData.firstName}!</h1>
          <p>Your submission has been received. Thank you for your interest!</p>
		  <p>You will now be redirected to a third party payment gateway</p>
          <button onClick={handleProceedToPayment}>Proceed to Payment</button>
        </div>
      </Home>
  );
};

export default ThankYou;
